import Swiper, { Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination } from 'swiper';

const defaultModules = {
  modules: [Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination]
};

export default class SwiperService {
  constructor() {
    throw new Error('Não é permitida a criação de instâncias desta classe');
  }

  /**
   * @param {object} objeto swiper config object {element,props}  https://idangero.us/swiper/api/
   * @return {object} swiper object Instance
   * Seta o swiper com os dados passados
   * https://idangero.us/swiper/api/
  */
  static setConfig(config) {
    this.el = config.element;

    // guarda o numero total de slides do carrossel antes de iniciar o swiper
    let totalSlides = $(this.el).find('.swiper-slide').length;

    this.config = {
      ...defaultModules,
      ...config.props,
      on: {
        init: function () {
          // se o carrossel tiver 1 slide, destroi o swiper dele logo apos a
          // inicializacao
          // isso para evitar algum bug que aconteca com 1 slide
          if (totalSlides <= 1) this.destroy();
        }
      }
    };

    this.swiper = new Swiper(this.el, this.config);
    // Seria mais simples colocar um if na linha de cima para instanciar o
    // swiper em carrosseis com 1+ slides, mas os de 1 slide nao teriam os
    // controles ocultados por exemplo

    return this.swiper;
  }
}